import JourneyCard from "../home/journey/card/journeyCard";
import GASOLINEIMG from "../../assets/png/1000_EFI _GASOLINE.png";
import TU01 from "../../assets/png/TU01.png";
import TUSC01 from "../../assets/png/TUSC01.png";
import { RouterPaths } from "../../router/router";

const Models = () => {
  const JourneyList = [
    {
      title: "GASOLINE",
      subTitle: "TU-1000EFI-2",
      img: GASOLINEIMG,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.EFI,
    },
    {
      title: "ELECTRIC",
      subTitle: "TU-1500E-2",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TU1500E2,
    },
    {
      title: "ELECTRIC",
      subTitle: "TU-1500E-3",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TU1500E3,
    },
    {
      title: "ELECTRIC",
      subTitle: "TU-1500E-4",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TU1500E4,
    },
    {
      title: "ELECTRIC DUAL MOTOR",
      subTitle: "2500E MODELS",
      img: TUSC01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TUDC2500E1,
    },
    {
      title: "ELECTRIC",
      subTitle: "1500E MODELS",
      img: TU01,
      Capacity: "2WD / 4WD",
      Models: 0,
      link: RouterPaths.TUSC2500E1,
    },
  ];
  return (
    <div className="bg-[#fff]">
      <div className="custom-container lg:pt-[90px] md:pt-[70px] sm:pt-[60px] pt-[50px] sm:pb-[260px] pb-[150px]">
        <div className="flex">
          <div className="font-[Rockwell] 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] font-extrabold lg:border-b-[5px] sm:border-b-[2px] border-b-[2px] border-[#7ABF5B] ">
            MODELS
          </div>
        </div>
        <div className="font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] mt-[40px]">
          Tuatara is built for those who need a reliable partner both on the job and on the trail. With features like
          selectable 2WD or 4WD, front and rear differential locks, hydraulic clutch, manual transmission, and
          heavy-duty towing and payload capacities, Tuatara vehicles are engineered to handle everything from
          construction sites to outdoor expeditions.
        </div>
        <div class="grid 2xl:grid-cols-3 xl:grid-cols-2 md:grid-cols-1 grid-cols-1 gap-8 lg:mt-[90px] md:mt-[70px] sm:mt-[60px] mt-[50px]">
          {JourneyList?.map((item) => {
            return <JourneyCard item={item} />;
          })}
        </div>
      </div>
    </div>
  );
};
export default Models;
